/* ==========================================================================
   IRON CREST LEATHER — corridor.js
   The image corridor animates entirely in CSS. This file owns two things and
   nothing else:

     1. the pause control, which toggles animation-play-state only, so cards
        resume from where they stopped rather than snapping back to the start;
     2. an observer that parks the rails while the section is off-screen —
        eighteen animated 3D layers are not worth compositing when nobody is
        looking at them.

   If this file never loads the corridor still runs; you just lose the control.

   Shopify: assets/corridor.js, loaded with `defer`.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    Array.prototype.forEach.call(document.querySelectorAll('.corridor'), function (section) {
      if (section.icBooted) return;   // already live; the editor replaced a different section
      section.icBooted = true;
      var toggle = section.querySelector('[data-corridor-toggle]');
      var label = section.querySelector('[data-corridor-label]');

      // Two independent reasons to be stopped. The rails run only when neither
      // applies, so scrolling away and back never overrides a manual pause.
      var pausedByUser = false;
      var offScreen = true;

      function apply() {
        var stopped = pausedByUser || offScreen;
        section.setAttribute('data-paused', stopped ? 'true' : 'false');
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', pausedByUser ? 'true' : 'false');
        toggle.setAttribute('aria-label', pausedByUser
          ? 'Play the moving jacket corridor'
          : 'Pause the moving jacket corridor');
        if (label) label.textContent = pausedByUser ? 'Play' : 'Pause';
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          pausedByUser = !pausedByUser;
          apply();
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          offScreen = !entries[0].isIntersecting;
          apply();
        }, { rootMargin: '15% 0px' }).observe(section);
      } else {
        offScreen = false;
      }

      // Reduced motion is handled in CSS, which also hides the control; keep the
      // state honest in case the preference changes while the page is open.
      function syncMotion() {
        if (reduced.matches) pausedByUser = false;
        apply();
      }
      if (reduced.addEventListener) reduced.addEventListener('change', syncMotion);

      syncMotion();
    });
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
